/**
 * Transfer API
 * 송금 관련 API 호출 함수
 */

import { apiClient } from '../../../../core/api/client';
import {
    TransferTarget,
    TransferRequest,
    TransferResponse,
    TransferTargetRequest,
} from '../types/transfer';

const BASE_PATH = '/api/v1/mob/withdrl';

/**
 * 송금 요청 API
 * POST /api/v1/mob/withdrl/transfer
 * @param request 송금 요청 데이터
 * @returns 송금 응답
 */
export const requestTransfer = async (
    request: TransferRequest
): Promise<TransferResponse> => {
    const response = await apiClient.post<TransferResponse>(
        `${BASE_PATH}/transfer`,
        request
    );
    return response.data;
};

/**
 * 송금 대상 목록 조회 API
 * GET /api/v1/mob/withdrl/transfer/targets
 * @param params 송금 대상 목록 조회 요청 파라미터
 * @returns 송금 대상 목록
 */
export const getTransferTargets = async (
    params?: TransferTargetRequest
): Promise<TransferTarget[]> => {
    const response = await apiClient.get<TransferTarget[]>(
        `${BASE_PATH}/transfer/targets`,
        { params }
    );
    return response.data;
};
